import { webTitle } from "@/config/index";
import storage from "@/utils/storage";
import { isNull } from "@/utils/utils";
import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  /**网页不能回退-1*/
  scrollBehavior: () => {
    history.pushState(history.state, "", document.URL);
  },

  routes: [
    /**登录和错误页面*/
    {
      name: "login",
      path: "/login",
      component: () => import("@/views/login/LoginPage.vue"),
      //component: () => import("@/views/sys/login/LoginPage.vue"),
      meta: { title: "OTMS" },
    },
    {
      name: "error-page",
      path: "/error-page",
      component: () => import("@/views/ErrorPage.vue"),
      meta: { title: webTitle + " / 页面出错了" },
    },
    {
      name: "not-page",
      path: "/:pathMatch(.*)*",
      component: () => import("@/views/NotPage.vue"),
      meta: { title: webTitle + " / 页面不存在" },
    },

   

    /**系统*/
    {
      name: "sys-login-page",
      path: "/sys-login-page",
      component: () => import("@/views/sys/login/LoginPage.vue"),
      meta: { title: webTitle + " / 系统管理" },
    },
    {
      name: "sys-index-page",
      path: "/sys-index-page",
      component: () => import("@/views/sys/index/IndexPage.vue"),
      children: [
        {
          name: "sys-index-user-view",
          path: "/sys-index-user-view",
          component: () => import("@/views/sys/user/UserView.vue"),
          meta: { title: webTitle + " / 系统管理 / 基本信息" },
        },
        {
          name: "sys-index-member-list",
          path: "/sys-index-member-list",
          component: () => import("@/views/sys/member/MemberList.vue"),
          meta: { title: webTitle + " / 系统管理 / 客户信息" },
        },
        {
          name: "sys-index-place-list",
          path: "/sys-index-place-list",
          component: () => import("@/views/sys/place/PlaceList.vue"),
          meta: { title: webTitle + " / 系统管理 / 站点信息" },
        },
        {
          name: "sys-index-node-list",
          path: "/sys-index-node-list",
          component: () => import("@/views/sys/node/NodeList.vue"),
          meta: { title: webTitle + " / 系统管理 / 栏目信息" },
        },
        {
          name: "sys-index-log-login-list",
          path: "/sys-index-log-login-list",
          component: () => import("@/views/sys/log/LogLoginList.vue"),
          meta: { title: webTitle + " / 系统管理 / 登录日志" },
        },
        {
          name: "sys-index-log-change-list",
          path: "/sys-index-log-change-list",
          component: () => import("@/views/sys/log/LogChangeList.vue"),
          meta: { title: webTitle + " / 系统管理 / 操作日志" },
        },
        {
          name: "sys-index-log-error-list",
          path: "/sys-index-log-error-list",
          component: () => import("@/views/sys/log/LogErrorList.vue"),
          meta: { title: webTitle + " / 系统管理 / 操作错误" },
        },
      ],
      meta: { title: webTitle + " / 管理员" },
    },

    /**客户后台*/
    {
      name: "/admin-index-page",
      path: "/admin-index-page",
      component: () => import("@/views/admin/index/IndexPage.vue"),
      children: [
        {
          name: "admin-index-member-view",
          path: "/admin-index-member-view",
          component: () => import("@/views/admin/member/MemberView.vue"),
          meta: { title: webTitle + " / 管理员 / 客户信息" },
        },
        {
          name: "admin-index-member-password",
          path: "/admin-index-member-password",
          component: () => import("@/views/admin/member/MemberPassword.vue"),
          meta: { title: webTitle + " / 管理员 / 修改密码" },
        },
        {
          name: "admin-index-user-list",
          path: "/admin-index-user-list",
          component: () => import("@/views/admin/user/UserList.vue"),
          meta: { title: webTitle + " / 管理员 / 用户信息" },
        },
        {
          name: "admin-index-node-list",
          path: "/admin-index-node-list",
          component: () => import("@/views/admin/node/NodeList.vue"),
          meta: { title: webTitle + " / 管理员 / 菜单权限" },
        },
        {
          name: "admin-index-role-list",
          path: "/admin-index-role-list",
          component: () => import("@/views/admin/role/RoleList.vue"),
          meta: { title: webTitle + " / 管理员 / 角色信息" },
        },
        {
          name: "admin-index-place-bind-list",
          path: "/admin-index-place-bind-list",
          component: () => import("@/views/admin/place/PlaceBindList.vue"),
          meta: { title: webTitle + " / 管理员 / 站点绑定" },
        },
        {
          name: "admin-index-log-login-list",
          path: "/admin-index-log-login-list",
          component: () => import("@/views/admin/log/LogLoginList.vue"),
          meta: { title: webTitle + " / 管理员 / 登录日志" },
        },
        {
          name: "admin-index-log-change-list",
          path: "/admin-index-log-change-list",
          component: () => import("@/views/admin/log/LogChangeList.vue"),
          meta: { title: webTitle + " / 管理员 / 操作日志" },
        },
      ],
      meta: { title: webTitle + " / 管理员" },
    },

    /**工作*/
    {
      name: "index-page",
      path: "/index-page",
      component: () => import("@/views/IndexPage.vue"),
      children: [
        /**工作台*/
        {
          name: "home-page",
          path: "/home-page",
          component: () => import("@/views/HomePage.vue"),
          meta: { title: webTitle + " / 首页" },
        },

        /**移动页面菜单*/
        {
          name: "mobile-side-bar",
          path: "/mobile-side-bar",
          component: () => import("@/components/MobileSideBar.vue"),
          meta: { title: webTitle + " / 菜单" },
        },

        /**测试*/
        {
          name: "temp-page",
          path: "/temp-page/:id",
          component: () => import("@/views/TempPage.vue"),
          meta: { title: webTitle + " / 测试页面" },
        },

        /**参数管理 */
        {
          name: "param-index-send-index-send-list",
          path: "/param-index-send-index-send-list/:id",
          component: () => import("@/views/work/param/send/SendList.vue"),
          meta: { title: webTitle + " / 参数管理 / 发货方" },
        },
        {
          name: "param-index-receive-index-receive-list",
          path: "/param-index-receive-index-receive-list/:id",
          component: () => import("@/views/work/param/receive/ReceiveList.vue"),
          meta: { title: webTitle + " / 参数管理 / 收货方" },
        },
        {
          name: "param-index-carrier-index-carrier-list",
          path: "/param-index-carrier-index-carrier-list/:id",
          component: () => import("@/views/work/param/carrier/CarrierList.vue"),
          meta: { title: webTitle + " / 参数管理 / 承运商" },
        },
        {
          name: "param-index-vehicle-index-vehicle-list",
          path: "/param-index-vehicle-index-vehicle-list/:id",
          component: () => import("@/views/work/param/vehicle/VehicleList.vue"),
          meta: { title: webTitle + " / 参数管理 / 短途车辆" },
        },
        {
          name: "param-index-sign-in-index-sign-in-list",
          path: "/param-index-sign-in-index-sign-in-list/:id",
          component: () => import("@/views/work/param/signin/SignInList.vue"),
          meta: { title: webTitle + " / 参数管理 / 签收人" },
        },
        {
          name: "param-index-charge-index",
          path: "/param-index-charge-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 参数管理 / 报价设置" },

          children: [
            {
              name: "param-index-charge-index-consignment-charge-list",
              path: "/param-index-charge-index-consignment-charge-list/:id",
              component: () => import("@/views/work/param/charge/consignment/ConsignmentChargeList.vue"),
              meta: { 
                title: webTitle + " / 参数管理 / 报价设置 / 托单报价",
                activeMenu: "/param-index-charge-index",
               },
            },
            {
              name: "param-index-charge-index-consignment-charge-detailed-list",
              path: "/param-index-charge-index-consignment-charge-detailed-list/:id",
              component: () => import("@/views/work/param/charge/consignment/ConsignmentChargeDetailedList.vue"),
              meta: { 
                title: webTitle + " / 参数管理 / 报价设置 / 托单报价明细",
                activeMenu: "/param-index-charge-index",
               },
            },  
            {
              name: "param-index-charge-index-long-charge-list",
              path: "/param-index-charge-index-long-charge-list/:id",
              component: () => import("@/views/work/param/charge/long/LongChargeList.vue"),
              meta: { 
                title: webTitle + " / 参数管理 / 报价设置 / 承运商报价",
                activeMenu: "/param-index-charge-index",
               },
            },  
            {
              name: "param-index-charge-index-long-charge-detailed-list",
              path: "/param-index-charge-index-long-charge-detailed-list/:id",
              component: () => import("@/views/work/param/charge/long/LongChargeDetailedList.vue"),
              meta: { 
                title: webTitle + " / 参数管理 / 报价设置 / 承运商报价明细",
                activeMenu: "/param-index-charge-index",
               },
            },   
            {
              name: "param-index-charge-index-load-unload-charge-list",
              path: "/param-index-charge-index-load-unload-charge-list/:id",
              component: () => import("@/views/work/param/charge/load/LoadUnloadChargeList.vue"),
              meta: { 
                title: webTitle + " / 参数管理 / 报价设置 / 装卸报价",
                activeMenu: "/param-index-charge-index",
               },
            },  
            {
              name: "param-index-charge-index-operate-charge-list",
              path: "/param-index-charge-index-operate-charge-list/:id",
              component: () => import("@/views/work/param/charge/operate/OperateChargeList.vue"),
              meta: { 
                title: webTitle + " / 参数管理 / 报价设置 / 操作报价",
                activeMenu: "/param-index-charge-index",
               },
            },     
          ],
        },
        {
          name: "param-index-receive-note-index-receive-note-list",
          path: "/param-index-receive-note-index-receive-note-list/:id",
          component: () =>
            import("@/views/work/param/receivenote/ReceiveNoteList.vue"),
            meta: { title: webTitle + " / 参数管理 / 收货方记录" },
        },
        {
          name: "param-index-category-index-category-list",
          path: "/param-index-category-index-category-list/:id",
          component: () =>
            import("@/views/work/param/category/CategoryList.vue"),
            meta: { title: webTitle + " / 参数管理 / 参数分类" },
        },
        {
          name: "param-index-recipient-index-recipient-list",
          path: "/param-index-recipient-index-recipient-list/:id",
          component: () =>
            import("@/views/work/param/recipient/RecipientList.vue"),
            meta: { title: webTitle + " / 参数管理 / 收款信息" },
        },
         {
          name: "param-index-receive-visit-index-receive-visit-list",
          path: "/param-index-receive-visit-index-receive-visit-list/:id",
          component: () =>
            import("@/views/work/param/receivevisit/ReceiveVisitList.vue"),
            meta: { title: webTitle + " / 参数管理 / 收货方访问" },
        },
        {
          name: "param-index-template-set-index-template-set-list",
          path: "/param-index-template-set-index-template-set-list/:id",
          component: () =>
            import("@/views/work/param/templateset/TemplateSetList.vue"),
          meta: { title: webTitle + " / 参数管理 / 模版设置" },
        },
        {
          name: "param-index-template-use-index-template-use-list",
          path: "/param-index-template-use-index-template-use-list/:id",
          component: () =>
            import("@/views/work/param/templateuse/TemplateUseList.vue"),
          meta: { title: webTitle + " / 参数管理 / 模版使用" },
        },

        /**公共查询-开始*/
        {
          name: "business-index-common-query-index",
          path: "/business-index-common-query-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 运营管理 / 公共查询" },

          children: [
           
            {
              name: "business-index-common-query-index-storage-goods-list",
              path: "/business-index-common-query-index-storage-goods-list/:id",
              component: () =>
                import("@/views/work/business/query/StorageGoodsList.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 公共查询 / 入库信息 ",
                activeMenu: "/business-index-common-query-index",
              },
            },
            {
              name: "business-index-common-query-index-consignment-note-list",
              path: "/business-index-common-query-index-consignment-note-list/:id",
              component: () =>
                import("@/views/work/business/query/ConsignmentNoteList.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 公共查询 / 托单信息 ",
                activeMenu: "/business-index-common-query-index",
              },
            },
            
          ],
        },
        /**公共查询-结束 */

        /**仓储管理-开始*/
        {
          name: "business-index-storage-index",
          path: "/business-index-storage-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 运营管理 / 仓储管理" },

          children: [
            {
              name: "business-index-storage-index-storage-tips",
              path: "/business-index-storage-index/:id",
              component: () =>
                import("@/views/work/business/storage/StorageTips.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 仓储管理 / 概况",
                activeMenu: "/business-index-storage-index",
              },
            },

            {
              name: "business-index-storage-index-storage-upload-list",
              path: "/business-index-storage-index-storage-upload-list/:id",
              component: () =>
                import("@/views/work/business/storage/StorageUploadList.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 仓储管理 / 上传入库",
                activeMenu: "/business-index-storage-index",
              },
            },
            {
              name: "business-index-storage-index-storage-accept-list",
              path: "/business-index-storage-index-storage-accept-list/:id",
              component: () =>
                import("@/views/work/business/storage/StorageAcceptList.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 仓储管理 / 调拨入库",
                activeMenu: "/business-index-storage-index",
              },
            },
            {
              name: "business-index-storage-index-storage-update-list",
              path: "/business-index-storage-index-storage-update-list/:id",
              component: () =>
                import("@/views/work/business/storage/StorageUpdateList.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 仓储管理 / 入库清单",
                activeMenu: "/business-index-storage-index",
              },
            },
            {
              name: "business-index-storage-index-storage-count-list",
              path: "/business-index-storage-index-storage-count-list/:id",
              component: () =>
                import("@/views/work/business/storage/StorageCountList.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 仓储管理 / 库存统计",
                activeMenu: "/business-index-storage-index",
              },
            },
          ],
        },
        /**仓储管理-结束 */

        /**托单管理-开始*/
        {
          name: "business-index-consignment-note-index",
          path: "/business-index-consignment-note-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 运营管理 / 托单管理" },

          children: [
            {
              name: "business-index-consignment-note-index-consignment-tips",
              path: "/business-index-consignment-note-index/:id",
              component: () =>
                import("@/views/work/business/consignment/ConsignmentTips.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 托单管理 / 概况",
                activeMenu: "/business-index-consignment-index",
              },
            },

            {
              name: "business-index-consignment-note-index-consignment-quick-count-prepare-list",
              path: "/business-index-consignment-note-index-consignment-quick-count-prepare-list/:id",
              component: () =>
                import(
                  "@/views/work/business/consignment/ConsignmentQuickCountPrepareList.vue"
                ),
              meta: {
                title: webTitle + " / 运营管理 / 托单管理 / 快捷制单",
                activeMenu: "/business-index-consignment-note-index",
              },
            },

            {
              name: "business-index-consignment-note-index-consignment-stock-list",
              path: "/business-index-consignment-note-index-consignment-stock-list/:id",
              component: () =>
                import(
                  "@/views/work/business/consignment/ConsignmentStockList.vue"
                ),
              meta: {
                title: webTitle + " / 运营管理 / 托单管理 / 制单",
                activeMenu: "/business-index-consignment-note-index",
              },
            },

            {
              name: "business-index-consignment-note-index-consignment-update-list",
              path: "/business-index-consignment-note-index-consignment-update-list/:id",
              component: () =>
                import(
                  "@/views/work/business/consignment/ConsignmentUpdateList.vue"
                ),
              meta: {
                title: webTitle + " / 运营管理 / 托单管理 / 修改托单",
                activeMenu: "/business-index-consignment-note-index",
              },
            },
            {
              name: "business-index-consignment-note-index-consignment-special-update-list",
              path: "/business-index-consignment-note-index-consignment-special-update-list/:id",
              component: () =>
                import(
                  "@/views/work/business/consignment/ConsignmentSpecialUpdateList.vue"
                ),
              meta: {
                title: webTitle + " / 运营管理 / 托单管理 / 零费用清单",
                activeMenu: "/business-index-consignment-note-index",
              },
            },

            {
              name: "business-index-consignment-note-index-consignment-plan-update-list",
              path: "/business-index-consignment-note-index-consignment-plan-update-list/:id",
              component: () =>
                import(
                  "@/views/work/business/consignmentplan/ConsignmentPlanUpdateList.vue"
                ),
              meta: {
                title: webTitle + " / 运营管理 / 托单管理 / 计划托单",
                activeMenu: "/business-index-consignment-note-index",
              },
            },
          ],
        },
        /**托单管理-结束 */

        /**运输管理-开始*/
        {
          name: "business-index-long-index",
          path: "/business-index-long-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 运营管理 / 运输管理" },

          children: [
            {
              name: "business-index-long-index-long-tips",
              path: "/business-index-long-index/:id",
              component: () =>
                import("@/views/work/business/long/LongTips.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 运输管理 / 概况",
                activeMenu: "/business-index-long-index",
              },
            },

            {
              name: "business-index-long-index-long-loading-list",
              path: "/business-index-long-index-long-loading-list/:id",
              component: () =>
                import("@/views/work/business/long/LongLoadingList.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 运输管理 / 配载",
                activeMenu: "/business-index-long-index",
              },
            },
            {
              name: "business-index-long-index-long-consignment-update-list",
              path: "/business-index-long-index-long-consignment-update-list/:id",
              component: () =>
                import("@/views/work/business/long/LongConsignmentUpdateList.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 运输管理 / 配载清单",
                activeMenu: "/business-index-long-index",
              },
            },
            {
              name: "business-index-long-index-long-start-track-list",
              path: "/business-index-long-index-long-start-track-list/:id",
              component: () =>
                import("@/views/work/business/long/LongStartTrackList.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 运输管理 / 【发站】跟踪",
                activeMenu: "/business-index-long-index",
              },
            },
           
            {
              name: "business-index-long-index-long-arrive-track-list",
              path: "/business-index-long-index-long-arrive-track-list/:id",
              component: () =>
                import("@/views/work/business/long/LongArriveTrackList.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 运输管理 / 【到站】跟踪",
                activeMenu: "/business-index-long-index",
              },
            },
            
          ],
        },
        /**运输管理-结束 */



        /**发货管理-开始*/
        {
          name: "business-index-long-single-index",
          path: "/business-index-long-single-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 运营管理 / 发货管理" },

          children: [
            {
              name: "business-index-long-single-index-long-tips",
              path: "/business-index-long-single-index/:id",
              component: () =>
                import("@/views/work/business/longsingle/LongTips.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 发货管理 / 概况",
                activeMenu: "/business-index-long-single-index",
              },
            },

            {
              name: "business-index-long-single-index-long-prepare-list",
              path: "/business-index-long-single-index-long-prepare-list/:id",
              component: () =>
                import("@/views/work/business/longsingle/LongPrepareList.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 发货管理 / 配载",
                activeMenu: "/business-index-long-single-index",
              },
            },           

            {
              name: "business-index-long-single-index-long-update-list",
              path: "/business-index-long-single-index-long-update-list/:id",
              component: () =>
                import("@/views/work/business/longsingle/LongUpdateList.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 发货管理 / 发货清单",
                activeMenu: "/business-index-long-single-index",
              },
            },    
            {
              name: "business-index-long-single-index-long-start-track-list",
              path: "/business-index-long-single-index-long-start-track-list/:id",
              component: () =>
                import("@/views/work/business/longsingle/LongStartTrackList.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 发货管理 / 【发站】跟踪",
                activeMenu: "/business-index-long-single-index",
              },
            },
            {
              name: "business-index-long-single-index-long-arrive-track-list",
              path: "/business-index-long-single-index-long-arrive-track-list/:id",
              component: () =>
                import("@/views/work/business/longsingle/LongArriveTrackList.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 发货管理 / 【到站】跟踪",
                activeMenu: "/business-index-long-single-index",
              },
            },
            {
              name: "business-index-long-single-index-long-start-detail-track-list",
              path: "/business-index-long-single-index-long-start-detail-track-list/:id",
              component: () =>
                import("@/views/work/business/longsingle/LongStartDetailTrackList.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 发货管理 / 【发站】明细跟踪",
                activeMenu: "/business-index-long-single-index",
              },
            },
            {
              name: "business-index-long-single-index-long-arrive-detail-track-list",
              path: "/business-index-long-single-index-long-arrive-detail-track-list/:id",
              component: () =>
                import("@/views/work/business/longsingle/LongArriveDetailTrackList.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 发货管理 / 【到站】明细跟踪",
                activeMenu: "/business-index-long-single-index",
              },
            },
             {
              name: "business-index-long-single-index-long-fee-list",
              path: "/business-index-long-single-index-long-fee-list/:id",
              component: () =>
                import("@/views/work/business/longsingle/LongFeeList.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 发货管理 / 费用明细",
                activeMenu: "/business-index-long-single-index",
              },
            },

              {
              name: "business-index-long-single-index-long-special-update-list",
              path: "/business-index-long-single-index-long-special-update-list/:id",
              component: () =>
                import("@/views/work/business/longsingle/LongSpecialUpdateList.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 发货管理 / 零费用清单",
                activeMenu: "/business-index-long-single-index",
              },
            },

          ],
        },
        /**发货管理-结束 */



        /**签收管理-开始*/
        {
          name: "business-index-sign-in-index",
          path: "/business-index-sign-in-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 运营管理 / 签收管理" },

          children: [
            {
              name: "business-index-sign-in-index-sign-in-tips",
              path: "/business-index-sign-in-index/:id",
              component: () =>
                import("@/views/work/business/signin/SignInTips.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 签收管理 / 概况",
                activeMenu: "/business-index-sign-in-index",
              },
            },

            {
              name: "business-index-sign-in-index-sign-in-start-prepare-list",
              path: "/business-index-sign-in-index-sign-in-start-prepare-list/:id",
              component: () =>
                import(
                  "@/views/work/business/signin/SignInStartPrepareList.vue"
                ),
              meta: {
                title: webTitle + " / 运营管理 / 签收管理 / 【发站】签收",
                activeMenu: "/business-index-sign-in-index",
              },
            },
            {
              name: "business-index-sign-in-index-sign-in-arrive-prepare-list",
              path: "/business-index-sign-in-index-sign-in-arrive-prepare-list/:id",
              component: () =>
                import(
                  "@/views/work/business/signin/SignInArrivePrepareList.vue"
                ),
              meta: {
                title: webTitle + " / 运营管理 / 签收管理 / 【到站】签收",
                activeMenu: "/business-index-sign-in-index",
              },
            },
            {
              name: "business-index-sign-in-index-sign-in-update-list",
              path: "/business-index-sign-in-index-sign-in-update-list/:id",
              component: () =>
                import("@/views/work/business/signin/SignInUpdateList.vue"),
              meta: {
                title: webTitle + " / 运营管理 / 签收管理 / 签收清单",
                activeMenu: "/business-index-sign-in-index",
              },
            },
            // {
            //   name: "business-index-sign-in-index-sign-in-detail-list",
            //   path: "/business-index-sign-in-index-sign-in-detail-list/:id",
            //   component: () =>
            //     import("@/views/work/business/signin/SignInDetailList.vue"),
            //   meta: {
            //     title: webTitle + " / 运营管理 / 签收管理 / 签收明细",
            //     activeMenu: "/business-index-sign-in-index",
            //   },
            // },
          ],
        },
        /**签收管理-结束 */

         /**费用管理-托单应收-开始*/
        {
          name: "cost-index-consignment-index",
          path: "/cost-index-consignment-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 费用管理 / 托单应收" },

          children: [
            // {
            //   name: "cost-index-consignment-index-carry-fee-tips",
            //   path: "/cost-index-consignment-index/:id",
            //   component: () =>import("@/views/work/cost/consignment/CarryFeeTips.vue"),
            //   meta: {
            //     title: webTitle + " / 费用管理 / 托单应收 / 概况",
            //     activeMenu: "/cost-index-consignment-index",
            //   },
            // },
            {
              name: "cost-index-consignment-index-carry-fee-update-list",
              path: "/cost-index-consignment-index-carry-fee-update-list/:id",
              component: () =>import("@/views/work/cost/consignment/CarryFeeUpdateList.vue"),
              meta: {
                title: webTitle + " / 费用管理 / 托单应收 / 修改运费",
                activeMenu: "/cost-index-consignment-index",
              },
            },            
            {
              name: "cost-index-consignment-index-carry-fee-count-list",
              path: "/cost-index-consignment-index-carry-fee-count-list/:id",
              component: () =>import("@/views/work/cost/consignment/CarryFeeCountList.vue"),
              meta: {
                title: webTitle + " / 费用管理 / 托单应收 / 运费统计",
                activeMenu: "/cost-index-consignment-index",
              },
            },
          ],
        },
        /**费用管理-托单应收-开始 */

        /**费用管理-发货费用-开始*/
        {
          name: "cost-index-long-index",
          path: "/cost-index-long-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 费用管理 / 发货费用" },

          children: [
            // {
            //   name: "cost-index-consignment-index-carry-fee-tips",
            //   path: "/cost-index-consignment-index/:id",
            //   component: () =>import("@/views/work/cost/consignment/CarryFeeTips.vue"),
            //   meta: {
            //     title: webTitle + " / 费用管理 / 托单应收 / 概况",
            //     activeMenu: "/cost-index-consignment-index",
            //   },
            // },
            // {
            //   name: "cost-index-long-index-carry-fee-update-list",
            //   path: "/cost-index-long-index-carry-fee-update-list/:id",
            //   component: () =>import("@/views/work/cost/long/CarryFeeUpdateList.vue"),
            //   meta: {
            //     title: webTitle + " / 费用管理 / 发货费用 / 修改运费",
            //     activeMenu: "/cost-index-long-index",
            //   },
            // },            
            {
              name: "cost-index-long-index-carry-fee-count-list",
              path: "/cost-index-long-index-carry-fee-count-list/:id",
              component: () =>import("@/views/work/cost/long/CarryFeeCountList.vue"),
              meta: {
                title: webTitle + " / 费用管理 / 发货费用 / 运费统计",
                activeMenu: "/cost-index-long-index",
              },
            },
          ],
        },
        /**费用管理-发货费用-结束 */

        /**费用管理-装卸费用-开始*/
        {
          name: "cost-index-load-unload-index",
          path: "/cost-index-load-unload-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 费用管理 / 装卸费用" },

          children: [
            // {
            //   name: "cost-index-consignment-index-carry-fee-tips",
            //   path: "/cost-index-consignment-index/:id",
            //   component: () =>import("@/views/work/cost/consignment/CarryFeeTips.vue"),
            //   meta: {
            //     title: webTitle + " / 费用管理 / 托单应收 / 概况",
            //     activeMenu: "/cost-index-consignment-index",
            //   },
            // },
            {
              name: "cost-index-load-unload-index-load-unload-load-prepare-list",
              path: "/cost-index-load-unload-index-load-unload-load-prepare-list/:id",
              component: () =>import("@/views/work/cost/loadunload/LoadUnloadLoadPrepareList.vue"),
              meta: {
                title: webTitle + " / 费用管理 / 装卸费用 / 装车费用",
                activeMenu: "/cost-index-load-unload-index",
              },
            },            
            {
              name: "cost-index-load-unload-index-load-unload-unload-prepare-list",
              path: "/cost-index-load-unload-index-load-unload-unload-prepare-list/:id",
              component: () =>import("@/views/work/cost/loadunload/LoadUnloadUnloadPrepareList.vue"),
              meta: {
                title: webTitle + " / 费用管理 / 装卸费用 / 卸车费用",
                activeMenu: "/cost-index-load-unload-index",
              },
            },
            {
              name: "cost-index-load-unload-index-load-unload-direct-unload-prepare-list",
              path: "/cost-index-load-unload-index-load-unload-direct-unload-prepare-list/:id",
              component: () =>import("@/views/work/cost/loadunload/LoadUnloadDirectUnloadPrepareList.vue"),
              meta: {
                title: webTitle + " / 费用管理 / 装卸费用 / 直发卸车费用",
                activeMenu: "/cost-index-load-unload-index",
              },
            },
            {
              name: "cost-index-load-unload-index-load-unload-update-list",
              path: "/cost-index-load-unload-index-load-unload-update-list/:id",
              component: () =>import("@/views/work/cost/loadunload/LoadUnloadUpdateList.vue"),
              meta: {
                title: webTitle + " / 费用管理 / 装卸费用 / 装卸清单",
                activeMenu: "/cost-index-load-unload-index",
              },
            },
            {
              name: "cost-index-load-unload-index-load-unload-long-consignment-update-list",
              path: "/cost-index-load-unload-index-load-unload-long-consignment-update-list/:id",
              component: () =>import("@/views/work/cost/loadunload/LoadUnloadLongConsignmentUpdateList.vue"),
              meta: {
                title: webTitle + " / 费用管理 / 装卸费用 / 装卸明细",
                activeMenu: "/cost-index-load-unload-index",
              },
            },
            {
              name: "cost-index-load-unload-index-load-unload-count-list",
              path: "/cost-index-load-unload-index-load-unload-count-list/:id",
              component: () =>import("@/views/work/cost/loadunload/LoadUnloadCountList.vue"),
              meta: {
                title: webTitle + " / 费用管理 / 装卸费用 / 装卸统计",
                activeMenu: "/cost-index-load-unload-index",
              },
            },
          ],
        },
        /**费用管理-装卸费用-结束 */

        /**费用管理-操作费用-开始*/
        {
          name: "cost-index-operate-fee-index",
          path: "/cost-index-operate-fee-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 费用管理 / 操作费用" },

          children: [
            // {
            //   name: "cost-index-consignment-index-carry-fee-tips",
            //   path: "/cost-index-consignment-index/:id",
            //   component: () =>import("@/views/work/cost/consignment/CarryFeeTips.vue"),
            //   meta: {
            //     title: webTitle + " / 费用管理 / 托单应收 / 概况",
            //     activeMenu: "/cost-index-consignment-index",
            //   },
            // },
            {
              name: "cost-index-operate-fee-index-operate-fee-update-list",
              path: "/cost-index-operate-fee-index-operate-fee-update-list/:id",
              component: () =>import("@/views/work/cost/operatefee/OperateFeeUpdateList.vue"),
              meta: {
                title: webTitle + " / 费用管理 / 操作费用费用 / 操作费用清单",
                activeMenu: "/cost-index-operate-fee-index",
              },
            },            
            

          ],
        },
        /**费用管理-操作费用-结束 */

        /**费用管理-短途运输-开始*/
        {
          name: "cost-index-short-index",
          path: "/cost-index-short-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 费用管理 / 短途运输" },

          children: [
            // {
            //   name: "cost-index-consignment-index-carry-fee-tips",
            //   path: "/cost-index-consignment-index/:id",
            //   component: () =>import("@/views/work/cost/consignment/CarryFeeTips.vue"),
            //   meta: {
            //     title: webTitle + " / 费用管理 / 托单应收 / 概况",
            //     activeMenu: "/cost-index-consignment-index",
            //   },
            // },
            {
              name: "cost-index-short-index-short-transport-update-list",
              path: "/cost-index-short-index-short-transport-update-list/:id",
              component: () =>import("@/views/work/cost/short/ShortTransportUpdateList.vue"),
              meta: {
                title: webTitle + " / 费用管理 / 短途运输 / 短途清单",
                activeMenu: "/cost-index-short-index",
              },
            },            
            {
              name: "cost-index-short-index-short-transport-consignment-update-list",
              path: "/cost-index-short-index-short-transport-consignment-update-list/:id",
              component: () =>import("@/views/work/cost/short/ShortTransportConsignmentUpdateList.vue"),
              meta: {
                title: webTitle + " / 费用管理 / 短途运输 / 短途明细",
                activeMenu: "/cost-index-short-index",
              },
            }, 
            {
              name: "cost-index-short-index-short-transport-count-list",
              path: "/cost-index-short-index-short-transport-count-list/:id",
              component: () =>import("@/views/work/cost/short/ShortTransportCountList.vue"),
              meta: {
                title: webTitle + " / 费用管理 / 短途运输 / 短途统计",
                activeMenu: "/cost-index-short-index",
              },
            }, 
          ],
        },
        /**费用管理-短途运输-结束 */

         /**费用管理-短途运输-开始*/
        {
          name: "cost-index-other-index",
          path: "/cost-index-other-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 费用管理 / 其他费用" },

          children: [
            // {
            //   name: "cost-index-consignment-index-carry-fee-tips",
            //   path: "/cost-index-consignment-index/:id",
            //   component: () =>import("@/views/work/cost/consignment/CarryFeeTips.vue"),
            //   meta: {
            //     title: webTitle + " / 费用管理 / 托单应收 / 概况",
            //     activeMenu: "/cost-index-consignment-index",
            //   },
            // },
            {
              name: "cost-index-other-index-other-fee-update-list",
              path: "/cost-index-other-index-other-fee-update-list/:id",
              component: () =>import("@/views/work/cost/other/OtherFeeUpdateList.vue"),
              meta: {
                title: webTitle + " / 费用管理 / 其他费用 / 其他费用清单",
                activeMenu: "/cost-index-other-index",
              },
            },            
            {
              name: "cost-index-other-index-other-fee-consignment-update-list",
              path: "/cost-index-other-index-other-fee-consignment-update-list/:id",
              component: () =>import("@/views/work/cost/other/OtherFeeConsignmentUpdateList.vue"),
              meta: {
                title: webTitle + " / 费用管理 / 其他费用 / 其他费用明细",
                activeMenu: "/cost-index-other-index",
              },
            }, 
            {
              name: "cost-index-other-index-other-fee-count-list",
              path: "/cost-index-other-index-other-fee-count-list/:id",
              component: () =>import("@/views/work/cost/other/OtherFeeCountList.vue"),
              meta: {
                title: webTitle + " / 费用管理 / 其他费用 / 其他费用统计",
                activeMenu: "/cost-index-other-index",
              },
            }, 
          ],
        },
        /**费用管理-短途运输-结束 */

        /**费用管理-异常记录-开始*/
        {
          name: "cost-index-abnormal-index",
          path: "/cost-index-abnormal-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 费用管理 / 异常记录" },

          children: [
            // {
            //   name: "cost-index-consignment-index-carry-fee-tips",
            //   path: "/cost-index-consignment-index/:id",
            //   component: () =>import("@/views/work/cost/consignment/CarryFeeTips.vue"),
            //   meta: {
            //     title: webTitle + " / 费用管理 / 托单应收 / 概况",
            //     activeMenu: "/cost-index-consignment-index",
            //   },
            // },
            {
              name: "cost-index-abnormal-index-abnormal-record-add",
              path: "/cost-index-abnormal-index-abnormal-record-add/:id",
              component: () =>import("@/views/work/cost/abnormal/AbnormalRecordAdd.vue"),
              meta: {
                title: webTitle + " / 费用管理 / 异常记录 / 新增",
                activeMenu: "/cost-index-abnormal-index",
              },
            },            
           {
              name: "cost-index-abnormal-index-abnormal-record-update-list",
              path: "/cost-index-abnormal-index-abnormal-record-update-list/:id",
              component: () =>import("@/views/work/cost/abnormal/AbnormalRecordUpdateList.vue"),
              meta: {
                title: webTitle + " / 费用管理 / 异常记录 / 清单",
                activeMenu: "/cost-index-abnormal-index",
              },
            }, 
          ],
        },
        /**费用管理-异常记录-结束 */


         /**结账管理-应付结帐-开始*/
        {
          name: "check-index-expense-index",
          path: "/check-index-expense-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 结账管理 / 应付结账" },

          children: [
            // {
            //   name: "cost-index-consignment-index-carry-fee-tips",
            //   path: "/cost-index-consignment-index/:id",
            //   component: () =>import("@/views/work/cost/consignment/CarryFeeTips.vue"),
            //   meta: {
            //     title: webTitle + " / 费用管理 / 托单应收 / 概况",
            //     activeMenu: "/cost-index-consignment-index",
            //   },
            // },
            {
              name: "expense-index-bill-index-quick-count-prepare-index",
              path: "/expense-index-bill-index-quick-count-prepare-index/:id",
              component: () =>import("@/views/work/check/expense/bill/QuickCountPrepareIndex.vue"),
              meta: {
                title: webTitle + " / 结账管理 / 应付结账 / 新增账单",
                activeMenu: "/check-index-expense-index",
              },
            },            
            {
              name: "expense-index-bill-index-bill-update-list",
              path: "/expense-index-bill-index-bill-update-list/:id",
              component: () =>import("@/views/work/check/expense/bill/BillUpdateList.vue"),
              meta: {
                title: webTitle + " / 结账管理 / 应付结账 / 账单清单",
                activeMenu: "/check-index-expense-index",
              },
            }, 
            {
              name: "expense-index-invoice-index-invoice-note-prepare-list",
              path: "/expense-index-invoice-index-invoice-note-prepare-list/:id",
              component: () =>import("@/views/work/check/expense/invoice/InvoiceNotePrepareList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 应付结账 / 新增开票",
                activeMenu: "/check-index-expense-index",
              },
            }, 
              {
              name: "expense-index-invoice-index-invoice-note-update-list",
              path: "/expense-index-invoice-index-invoice-note-update-list/:id",
              component: () =>import("@/views/work/check/expense/invoice/InvoiceNoteUpdateList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 应付结账 / 开票清单",
                activeMenu: "/check-index-expense-index",
              },
            }, 
             {
              name: "expense-index-settle-index-settle-prepare-list",
              path: "/expense-index-settle-index-settle-prepare-list/:id",
              component: () =>import("@/views/work/check/expense/settle/SettlePrepareList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 应付结账 / 新增结算",
                activeMenu: "/check-index-expense-index",
              },
            }, 
              {
              name: "expense-index-settle-index-settle-update-list",
              path: "/expense-index-settle-index-settle-update-list/:id",
              component: () =>import("@/views/work/check/expense/settle/SettleUpdateList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 应付结账 / 结算清单",
                activeMenu: "/check-index-expense-index",
              },
            }, 
             {
              name: "expense-index-no-reconcile-index-count-list",
              path: "/expense-index-no-reconcile-index-count-list/:id",
              component: () =>import("@/views/work/check/expense/noreconcile/CountList.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 未对账 / 未对账统计",
                activeMenu: "/check-index-expense-index",
              },
            }, 
              {
              name: "expense-index-no-reconcile-index-count-list2",
              path: "/expense-index-no-reconcile-index-count-list2/:id",
              component: () =>import("@/views/work/check/expense/noreconcile/CountList2.vue"),
              meta: {
                title: webTitle + " / 结帐管理 / 未对账 / 未对账统计2",
                activeMenu: "/check-index-expense-index",
              },
            }, 
          ],
        },
        /**结账管理-应付结账-结束 */


         /**统计报表-发货毛利-开始*/
        {
          name: "count-index-consignment-index",
          path: "/count-index-consignment-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 统计报表 / 托单统计" },

          children: [
              {
              name: "count-index-consignment-index-send-province-count-list",
              path: "/count-index-consignment-index-send-province-count-list/:id",
              component: () =>import("@/views/work/count/consignment/SendProvinceCountList.vue"),
              meta: {
                title: webTitle + " / 统计报表 / 托单统计 / 发货省",
                activeMenu: "/count-index-consignment-index",
              },
            }, 
             {
              name: "count-index-consignment-index-send-name-count-list",
              path: "/count-index-consignment-index-send-name-count-list/:id",
              component: () =>import("@/views/work/count/consignment/SendNameCountList.vue"),
              meta: {
                title: webTitle + " / 统计报表 / 托单统计 / 发货方",
                activeMenu: "/count-index-consignment-index",
              },
            }, 
            {
              name: "count-index-consignment-index-send-company-count-list",
              path: "/count-index-consignment-index-send-company-count-list/:id",
              component: () =>import("@/views/work/count/consignment/SendCompanyCountList.vue"),
              meta: {
                title: webTitle + " / 统计报表 / 托单统计 / 发货单位",
                activeMenu: "/count-index-consignment-index",
              },
            }, 
             {
              name: "count-index-consignment-index-receive-province-count-list",
              path: "/count-index-consignment-index-receive-province-count-list/:id",
              component: () =>import("@/views/work/count/consignment/ReceiveProvinceCountList.vue"),
              meta: {
                title: webTitle + " / 统计报表 / 托单统计 / 收货省",
                activeMenu: "/count-index-consignment-index",
              },
            }, 
             {
              name: "count-index-consignment-index-receive-city-count-list",
              path: "/count-index-consignment-index-receive-city-count-list/:id",
              component: () =>import("@/views/work/count/consignment/ReceiveCityCountList.vue"),
              meta: {
                title: webTitle + " / 统计报表 / 托单统计 / 收货市",
                activeMenu: "/count-index-consignment-index",
              },
            }, 
            {
              name: "count-index-consignment-index-receive-name-count-list",
              path: "/count-index-consignment-index-receive-name-count-list/:id",
              component: () =>import("@/views/work/count/consignment/ReceiveNameCountList.vue"),
              meta: {
                title: webTitle + " / 统计报表 / 托单统计 / 收货方",
                activeMenu: "/count-index-consignment-index",
              },
            }, 
            {
              name: "count-index-consignment-index-site-name-count-list",
              path: "/count-index-consignment-index-site-name-count-list/:id",
              component: () =>import("@/views/work/count/consignment/SiteNameCountList.vue"),
              meta: {
                title: webTitle + " / 统计报表 / 托单统计 / 站点",
                activeMenu: "/count-index-consignment-index",
              },
            }, 
          ],
        },
        /**统计报表-发货统计-结束 */


          /**统计报表-发货统计-开始*/
        {
          name: "count-index-long-index",
          path: "/count-index-long-index/:id",
          component: () => import("@/components/BaseSubNode.vue"),
          meta: { title: webTitle + " / 统计报表 / 发货统计" },

          children: [
              {
              name: "count-index-long-index-carrier-name-count-list",
              path: "/count-index-long-index-carrier-name-count-list/:id",
              component: () =>import("@/views/work/count/long/CarrierNameCountList.vue"),
              meta: {
                title: webTitle + " / 统计报表 / 发货统计 / 承运商",
                activeMenu: "/count-index-long-index",
              },
            }, 
          ],
        },
        /**统计报表-发货统计-结束 */


      ],
    },


     /**协同操作-签收登录*/
     {
      name: "collaborate-login",
      path: "/collaborate-login/:type/:id",
      component: () => import("@/views/collaborate/LoginPage.vue"),
      meta: { title: "OTMS" },
    },

    /**协同操作-签收*/
    {
      name: "collaborate-index-sign-in-index-sign-in-prepare-list",
      path: "/collaborate-index-sign-in-index-sign-in-prepare-list/:type/:id",
      component: () => import("@/views/collaborate/signin/SignInPrepareList.vue"),
      meta: { title: "OTMS" },
    },


     /**协同操作-收货方访问-登录*/
     {
      name: "collaborate-login-receive-visit",
      path: "/collaborate-login-receive-visit/:id",
      component: () => import("@/views/collaborate/LoginPageReceiveVisit.vue"),
      meta: { title: "OTMS" },
    },

     /**协同操作-收货方访问-货物信息-查询*/
    {
      name: "collaborate-index-receive-visit-index-storage-goods-list",
      path: "/collaborate-index-receive-visit-index-storage-goods-list/:id",
      component: () => import("@/views/collaborate/receivevisit/StorageGoodsList.vue"),
      meta: { title: "OTMS" },
    },
  ],
});

/**路由守卫*/
router.beforeEach((to, from) => {
  //return;

  if (!isNull(storage.getItem("session", "basic", "token"))) {
    //const user: UserInfo = JSON.parse(new Tool().FormatToken(localStorage["token"]))
    //const expDate = toolObj.FormatDate(user.exp)
    if (to.path === "/login") {
      // if (expDate >= currDate) {
      //     return { path: "/desktop" }
      // } else {
      //     toolObj.ClearLocalStorage()
      // }
    } else {
      // if (expDate < currDate) {
      //     toolObj.ClearLocalStorage()
      //     return { path: "/login" }
      // }
    }
  } else {

     /**如果是协同登录直接返回*/
    if (to.path.includes("/collaborate-login/")) {
      return;
    } 
    if (to.path.includes("/collaborate-login-receive-visit/")) {
      return;
    } 

    
    /**避免无限重定向，因此要做个判断*/
    if (to.path !== "/login") {
      return { path: "/login" };
    }
  }
});

/**
 * 路由守卫，如果不是系统链接，返回到登录界面
 * 加上权限控制（考虑是否加权限）
 */
router.afterEach((to, from) => {
  /**把栏目名称赋值给页面title*/
  window.document.title = to.meta.title as any;

    /**如果是协同登录直接返回*/
     if (to.path.includes("/collaborate-login/")) {
      return;
    } 
    if (to.path.includes("/collaborate-login-receive-visit/")) {
      return;
    } 


  //return;

  /**
  let userId=''
  try
  {
      userId= storage.getItem('session', 'basic', 'userid')
      if(!isNull(userId))
      {
          //router.replace({ path: '/login' })
      }
      else {
          //避免无限重定向，因此要做个判断
          if (to.path !== "/login") {
              return { path: "/login" }
          }
      }
      console.log('用户id',userId)
  }
  catch(e)
  {
      router.replace({ path: '/login' })
  }
 */

  if (from.path === "/") {
    /**页面刷新不跳转*/
    if (window.performance.navigation.type == 1) {
      /**console.log("页面被刷新")*/
    } else {
      router.replace({ path: "/login" });
    }
  } else {
    /**如果没有权限，跳转到login*/
  }
});

export default router;
